import React, { useCallback, useEffect, useRef, useState } from "react";
import { HighlightedText } from "./HighlightedText";

export const TruncatedTitleLink = ({
	href,
	title,
	prefix = "",
	query = "",
	className = "",
	wrapperClassName = "",
	onClick,
	draggable = "false",
}) => {
	const linkRef = useRef(null);
	const [expanded, setExpanded] = useState(false);
	const [truncated, setTruncated] = useState(false);
	const fullTitle = `${prefix}${title || ""}`;

	const measure = useCallback(() => {
		const element = linkRef.current;
		if (!element) return false;

		const isTruncated =
			element.scrollWidth > element.clientWidth + 1 ||
			element.scrollHeight > element.clientHeight + 1;
		setTruncated(isTruncated);
		return isTruncated;
	}, []);

	useEffect(() => {
		measure();
		const element = linkRef.current;
		if (!element || typeof ResizeObserver === "undefined") return undefined;

		const observer = new ResizeObserver(() => measure());
		observer.observe(element);
		return () => observer.disconnect();
	}, [measure]);

	const showExpandedTitle = () => {
		setExpanded(measure());
	};

	return (
		<span className={`relative min-w-0 ${wrapperClassName}`}>
			<a
				ref={linkRef}
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				onClick={onClick}
				onMouseEnter={showExpandedTitle}
				onMouseLeave={() => setExpanded(false)}
				onFocus={showExpandedTitle}
				onBlur={() => setExpanded(false)}
				draggable={draggable}
				className={`line-clamp-1 min-w-0 ${className}`}
			>
				<HighlightedText query={query}>{fullTitle}</HighlightedText>
			</a>
			{expanded && truncated && (
				<div
					data-no-row-select
					className="pointer-events-none absolute left-0 top-full z-[80] mt-1 w-max max-w-[min(42rem,calc(100vw-2rem))] whitespace-normal break-words rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-primary)] px-3 py-2 text-sm font-semibold leading-snug text-[var(--color-link)] shadow-xl"
				>
					<HighlightedText query={query}>{fullTitle}</HighlightedText>
				</div>
			)}
		</span>
	);
};

export default TruncatedTitleLink;
